import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const simpleNationalOptantOptions = [
  { label: 'Sim', value: 'true' },
  { label: 'Não', value: 'false' },
]

export const simpleNationalOptantStrategy = optionsToStrategy(simpleNationalOptantOptions)
